import PropTypes from 'prop-types';
import React from 'react';
import './StripeCard.css';

const StripeCard = ({ children, className = '', title, subtitle, actions, style, ...props }) => {
  return (
    <div className={`stripe-card ${className}`} style={style} {...props}>
      {(title || subtitle || actions) && (
        <div className="stripe-card-header">
          <div className="stripe-card-header-content">
            {title && <h3 className="stripe-card-title">{title}</h3>}
            {subtitle && <p className="stripe-card-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="stripe-card-actions">{actions}</div>}
        </div>
      )}
      <div className="stripe-card-content">{children}</div>
    </div>
  );
};

StripeCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  style: PropTypes.object,
};

export default StripeCard;

